import React from "react";
import OrganizerSubscribeVideoAndContent from "../../pages/Organizer/components/OrganizerSubscribeVideoAndContent";
import useDialog from "hooks/useDialog";
import useAuth from "hooks/useAuth";
import { useNavigate } from "react-router-dom";

const NotSubscribed = ({ setIsOpenListDialog, isDashboard = false }) => {
  const { openSigninDialog } = useDialog();
  const { user } = useAuth();
  const navigate = useNavigate();

  const navigateToSignInFeeSection = () => {
    navigate("/");
    setTimeout(() => {
      const signInFeeSection = document.querySelector("#sign-in-fee-section");
      if (signInFeeSection) {
        signInFeeSection.scrollIntoView({ behavior: "smooth" });
      }
    }, 100); // Delay to ensure the home page has loaded
  };

  return (
    <div
      className={`h-auto max-w-[1550px] mx-auto rounded-[10px] grid place-items-center bg-white pt-[29px] lg:pt-[41px] pb-[100px] lg:pb-[41px] w-full px-5 lg:px-[48px]`}
    >
      <OrganizerSubscribeVideoAndContent
        handleButtonClick={() =>
          user ? navigateToSignInFeeSection() : openSigninDialog()
        }
        isVideoEnd={true}
        isDashboard={isDashboard}
      />
    </div>
  );
};

export default NotSubscribed;
